// extracted by mini-css-extract-plugin
export default {"panel":"OwnerModal_panel__7byKg","ownerScroll":"OwnerModal_ownerScroll__yKNub"};